import { Middleware } from 'redux';
import rootReducer from '../reducers/index';
import { AppState } from '../types/store';
import rootSaga, { studioRootSaga } from '../sagas';
import logger from '../helpers/logger';
import { rootModuleStoreFactory } from '@wix/da-shared-react/pkg/redux/rootModuleStore/factory';
import { IModuleStore } from 'redux-dynamic-modules-core';

export function configureStore(
  initialState: AppState,
  isStudio = false
): IModuleStore<AppState> {
  const middleware: Middleware[] = [];

  return rootModuleStoreFactory<AppState>(
    middleware,
    logger,
    initialState,
    rootReducer,
    isStudio ? studioRootSaga : rootSaga,
    false
  ) as IModuleStore<AppState>;
}
